import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PatientComponent } from './containers/patient/patient.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { PatientReadOnlyComponent } from './components/patient-read-only/patient-read-only.component';
import { PatientAppPopUpComponent } from './components/patient-app-popup/patient-app-popup.component';
import { PatientAppEditComponent } from './components/patient-app-edit/patient-app-edit.component';
import { PatientAppInlineComponent } from './components/patient-app-inline/patient-app-inline.component';
import { DateOfBirthPipe } from '@shared/pipes/date-of-birth.pipe';
import { UnifiedPatientsModule } from '@modules/unified-patients';
import { TlkRadioButtonComponent, TlkRadioGroupDirective } from '@itero/ui-toolkit-angular/radio-button';
import { EditIconComponent } from '@itero/ui-toolkit-angular/icons';
import { PatientCardComponent } from '@modules/patient-card';

@NgModule({
    declarations: [
        PatientComponent,
        PatientAppInlineComponent,
        PatientReadOnlyComponent,
        PatientAppPopUpComponent,
        PatientAppEditComponent,
        DateOfBirthPipe
    ],
    imports: [
        CommonModule,
        SharedModule,
        UnifiedPatientsModule,
        TlkRadioButtonComponent,
        TlkRadioGroupDirective,
        EditIconComponent,
        PatientCardComponent
    ],
    exports: [
        PatientComponent, PatientAppEditComponent,PatientAppInlineComponent
    ]
})
export class PatientModule {}
